export default function contactFormTurnstile() {
    // Sprawdź, czy Turnstile jest załadowany
    if (typeof turnstile === 'undefined') {
        console.warn('Cloudflare Turnstile nie jest załadowany.');
        return;
    }

    // Dodaj nasłuchiwanie na zdarzenia Contact Form 7
    document.addEventListener('wpcf7mailsent', function() {
        turnstile.reset(); // Reset po sukcesie wysłania
        console.log('Turnstile zresetowany po wysłaniu formularza.');
    }, false);

    document.addEventListener('wpcf7mailfailed', function() {
        turnstile.reset(); // Reset po błędzie wysyłki
        console.warn('Turnstile zresetowany po błędzie formularza.');
    }, false);

    document.addEventListener('wpcf7submit', function() {
        // Reset ogólny po każdym przesłaniu formularza
        turnstile.reset();
        console.log('Turnstile zresetowany po przesłaniu formularza.');
    }, false);
}
